// iOS 26+ paints the strip under the status bar with the page's own background and fades it into the content —
// the light body colour came out as a white haze over the navy headers. Keep the page background (and
// theme-color, which Safari and Android use for their bars) in the colour of the screen's top edge.
import { useEffect } from 'react';

export function useWebStatusBarColor(color: string) {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.style.backgroundColor = color;
    document.body.style.backgroundColor = color;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', color);
  }, [color]);
}
